import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  getCategories,
  removeArticle,
  createArticle
} from "../../actions/forum";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  Button,
  UncontrolledAlert
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import DropdownSelection from "../../components/Commons/DropdownSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/userforums/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";
import NewModal from "../../components/userforums/NewModal";
const CATEGORIES = [
  {
    id: 96,
    parent_id: 95,
    sort: 1,
    name: "job hunting",
    display_name: "工作求職"
  },
  {
    id: 97,
    parent_id: 95,
    sort: 2,
    name: "restaurant services",
    display_name: "餐館服務"
  },
  {
    id: 98,
    parent_id: 95,
    sort: 3,
    name: "housekeeping",
    display_name: "家政服務"
  },
  {
    id: 99,
    parent_id: 95,
    sort: 4,
    name: "repair and maintenance",
    display_name: "維修保養"
  },
  {
    id: 100,
    parent_id: 95,
    sort: 5,
    name: "business service",
    display_name: "商家服務"
  }
];
class ForumPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      articles: [],
      article: {
        category_ids: [96]
      },
      operationNewModal: false
    };
    this.goToPage = this.goToPage.bind(this);
    // this.onSearchInputChange = this.onSearchInputChange.bind(this);
    // this.filterCat = this.filterCat.bind(this);
    // this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.toggleNewModal = this.toggleNewModal.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType
    });
    this.getCategories();
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getCurrentCategory(category_id) {
    var matchRoles = CATEGORIES.filter(value => {
      return value.id == category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCategories() {
    this.props.getCategories();
  }

  hideAlert() {
    this.setState({
      alert: ""
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: ""
    });
    let path = "user";
    let post_id = row.post.id;
    this.props.removeArticle({ post_id, path });
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      )
    });
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams)
    });
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(parseInt(value));
    this.setState({
      article: {
        ...article,
        category_ids
      }
    });
  }

  toggleNewModal = state => {
    this.setState({
      operationNewModal: !this.state.operationNewModal
    });
  };

  submitArticle() {
    let { article } = this.state;
    const category_ids = article.category_ids;
    this.props.createArticle({
      category_ids
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      categories,
      errorMsg,
      successBackMsg,
      editArticleRequest,
      getArticleRequest
    } = this.props.forum;
    var activeCategoryType = this.state.activeCategoryType;

    const heads = ["標題", "分類", "發布日期", "浏览量", "回復量", "操作"];
    const dataAttributes = [
      "status",
      "title",
      "category",
      "author",
      "created_at"
    ];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between"></div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h3>美南論壇</h3>
              </div>
              <div className="d-flex align-items-center">
                <Button
                  className="btn btn-default"
                  onClick={this.toggleNewModal}
                >
                  發帖子
                </Button>
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={page => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
        <NewModal
          data={this.state.article}
          handleCheckBoxChange={this.handleCheckBoxChange}
          submitArticle={this.submitArticle}
          loading={editArticleRequest}
          toggleNewModal={this.toggleNewModal}
          operationNewModal={this.state.operationNewModal}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    forum: state.forum,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArticles: params => dispatch(getArticles(params)),
    getCategories: params => dispatch(getCategories(params)),
    removeArticle: params => dispatch(removeArticle(params)),
    createArticle: params => dispatch(createArticle(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumPage);
